import { createContext, useContext, useState, useCallback } from "react";

const WorkspaceContext = createContext(null);
const KEY = "mv_workspace";

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function WorkspaceProvider({ children }) {
  const [workspace, setWorkspace] = useState(read);

  // Persist region + inter-island flag so the correct regional data tables
  // (Caribbean Maritime vs US Overland) render instantly on entry/exit without
  // flashing the default schema while /meta resolves.
  const enterWorkspace = useCallback((id, name, region, enableInterislandTransit) => {
    const ws = {
      id,
      name,
      region: region || null,
      enable_interisland_transit:
        enableInterislandTransit != null
          ? !!enableInterislandTransit
          : region === "CARIBBEAN_MARITIME",
    };
    localStorage.setItem(KEY, JSON.stringify(ws));
    setWorkspace(ws);
  }, []);

  const exitWorkspace = useCallback(() => {
    localStorage.removeItem(KEY);
    setWorkspace(null);
  }, []);

  return (
    <WorkspaceContext.Provider value={{ workspace, enterWorkspace, exitWorkspace }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export const useWorkspace = () => useContext(WorkspaceContext);
